import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getWidgetAvatarUploadUrl = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: "widget/avatar-upload-url",
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true,
    });
};
